import { DarkFaEdit } from '../../../order/overview/Summary/DarkFaEdit';
import { TransactionValidationSchemaGenerator } from 'components/order/overview/EditTransactionPrice/TransactionValidationSchema';
import React, { ReactNode, useState } from 'react';
import { FlexRow, NavigationItem, SmallBodyText, BoldHeader5Text } from 'ui-toolkit';
import { SingleFieldInlineEditForm } from './SingleFieldEditForm';
import { ISummaryItemProps } from './SummaryItem';
import { StyledSummaryItem } from './SummaryItem.styles';
import { useShouldSummaryItemRender } from '../useShouldSummaryItemRender';
import { ITransaction } from '../../../../ui-toolkit/orders/interfaces/ITransaction';
import { IOrderDetailsData } from '../../../../ui-toolkit/orders/interfaces/IOrderDetailsData';

export interface ISummaryItemWithEditProps<T> extends ISummaryItemProps {
  field: keyof ITransaction;
  onUpdate: (field: keyof ITransaction, value: any) => Promise<void>;
  order: IOrderDetailsData;
  editControl: React.FC<T>;
  editProps: Partial<T>;
  children: ReactNode;
  'data-test-id'?: string;
}

export const SummaryItemWithEdit = <T extends any>({
  children,
  label,
  editControl: EditControl,
  editProps,
  field,
  onUpdate,
  order,
  'data-test-id': dataTestId,
  tab,
}: ISummaryItemWithEditProps<T>) => {
  const [show, setShow] = useState<boolean>(false);
  const shouldRender = useShouldSummaryItemRender(label, tab);
  if (!shouldRender) {
    return null;
  }
  return (
    <StyledSummaryItem>
      <FlexRow justifyContent={'space-between'}>
        <BoldHeader5Text>{label}</BoldHeader5Text>
        <NavigationItem text={`Edit ${label}`} onClick={() => setShow(!show)}>
          <DarkFaEdit data-test-id={dataTestId} />
        </NavigationItem>
      </FlexRow>
      <SmallBodyText>
        {!show && children}
        {show && (
          <SingleFieldInlineEditForm
            onUpdate={(value) => onUpdate(field, value)}
            initialValue={order.transaction[field]}
            onClose={() => setShow(false)}
            validationSchema={TransactionValidationSchemaGenerator(order.transaction.transaction_category, field)}
          >
            <EditControl {...(editProps as any)} name={`value`} data-test-id={field} />
          </SingleFieldInlineEditForm>
        )}
      </SmallBodyText>
    </StyledSummaryItem>
  );
};
